import { ProductSettlementFinanceGroupsDto } from './finance-groups.dto';

export class ProductSettlementFinanceDto {
  generalLedgerAccount: string;
  financeGroups: ProductSettlementFinanceGroupsDto;
  ownershipType: string;
  id?: string;

  constructor(d?: ProductSettlementFinanceDto) {
    if (!d) {
      return;
    }

    this.generalLedgerAccount = d.generalLedgerAccount;
    this.financeGroups = new ProductSettlementFinanceGroupsDto(d.financeGroups);
    this.ownershipType = d.ownershipType;
    this.id = d.id;
  }
}
